<template>
  <div>
    <v-toolbar color="primary" :dark="$store.getters.darkTheme">
      <v-toolbar-title>Admin Panel</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn text class="mr-2" to="/admin/ops">Operations Center</v-btn>
    </v-toolbar>
    <v-tabs v-model="tab" class="admin-tabs" grow show-arrows>
      <v-tab>Users</v-tab>
      <v-tab v-if="$store.getters.isPlatformAdmin">Email</v-tab>
      <v-tab v-if="$store.getters.isPlatformAdmin">Settings</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <admin-users @error="showError" @success="showSuccess" />
      </v-tab-item>
      <v-tab-item v-if="$store.getters.isPlatformAdmin">
        <admin-email @error="showError" @success="showSuccess" />
      </v-tab-item>
      <v-tab-item v-if="$store.getters.isPlatformAdmin">
        <admin-settings @error="showError" @success="showSuccess" />
      </v-tab-item>
    </v-tabs-items>

    <!-- Snackbar for notifications -->
    <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="3000">
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false"> Close </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import AdminUsers from "../components/admin/AdminUsers.vue";
import AdminEmail from "../components/admin/AdminEmail.vue";
import AdminSettings from "../components/admin/AdminSettings.vue";

export default {
  name: "AdminView",
  components: {
    AdminUsers,
    AdminEmail,
    AdminSettings
  },
  data() {
    return {
      tab: 0,
      snackbar: false,
      snackbarText: "",
      snackbarColor: "success"
    };
  },
  methods: {
    showSuccess(message) {
      this.snackbarText = message;
      this.snackbarColor = "success";
      this.snackbar = true;
    },
    showError(message) {
      this.snackbarText = message;
      this.snackbarColor = "error";
      this.snackbar = true;
    }
  }
};
</script>

<style scoped>
.admin-tabs {
  background-color: var(--light-bg-off-white) !important;
}
</style>
